// Nao publicar path de UI em `orquestra-contract` — RF3.2 satisfeita por vacuidade.
import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'orquestra',
});

// AS-IS (pre-existentes)
export const processAsIsListRouteRef = createSubRouteRef({
  id: 'orquestra.process-as-is.list',
  parent: rootRouteRef,
  path: '/projects/:projectId/process-as-is',
});

export const processAsIsNewRouteRef = createSubRouteRef({
  id: 'orquestra.process-as-is.new',
  parent: rootRouteRef,
  path: '/projects/:projectId/process-as-is/new',
});

export const processAsIsEditRouteRef = createSubRouteRef({
  id: 'orquestra.process-as-is.edit',
  parent: rootRouteRef,
  path: '/projects/:projectId/process-as-is/:processId/edit',
});

export const processAsIsViewRouteRef = createSubRouteRef({
  id: 'orquestra.process-as-is.view',
  parent: rootRouteRef,
  path: '/projects/:projectId/process-as-is/:processId/view',
});

// Gaps (agregado por projeto — F2)
export const gapsAggregatedRouteRef = createSubRouteRef({
  id: 'orquestra.gaps.aggregated',
  parent: rootRouteRef,
  path: '/projects/:projectId/gaps',
});

export const gapNewRouteRef = createSubRouteRef({
  id: 'orquestra.gaps.new',
  parent: rootRouteRef,
  path: '/projects/:projectId/gaps/new',
});

export const gapEditRouteRef = createSubRouteRef({
  id: 'orquestra.gaps.edit',
  parent: rootRouteRef,
  path: '/projects/:projectId/gaps/:gapId/edit',
});

// Activities
export const activityNewRouteRef = createSubRouteRef({
  id: 'orquestra.activity.new',
  parent: rootRouteRef,
  path: '/projects/:projectId/atividades/nova',
});

export const activityEditRouteRef = createSubRouteRef({
  id: 'orquestra.activity.edit',
  parent: rootRouteRef,
  path: '/projects/:projectId/atividades/:activityId/editar',
});

// Overview / Projetos
// NOTA: Nao existe `projectsOverviewRouteRef` como `createSubRouteRef` porque
// o Backstage proibe subRouteRef com `path: '/'` ("SubRouteRef path must not
// end with '/'"). Para navegar para a overview, use `rootRouteRef` ou uma
// navegacao relativa (`navigate('/')` dentro do plugin).

export const projectNewRouteRef = createSubRouteRef({
  id: 'orquestra.projects.new',
  parent: rootRouteRef,
  path: '/projects/new',
});

export const projectDetailRouteRef = createSubRouteRef({
  id: 'orquestra.projects.detail',
  parent: rootRouteRef,
  path: '/projects/:id',
});

export const projectEditRouteRef = createSubRouteRef({
  id: 'orquestra.projects.edit',
  parent: rootRouteRef,
  path: '/projects/:id/edit',
});

// Planning
export const planningRouteRef = createSubRouteRef({
  id: 'orquestra.planning',
  parent: rootRouteRef,
  path: '/projects/:id/planning',
});

/** @deprecated manter apenas por compatibilidade de link legado */
export const planningGanttRouteRef = createSubRouteRef({
  id: 'orquestra.planning.gantt',
  parent: rootRouteRef,
  path: '/projects/:id/planning/gantt',
});

export const phaseNewRouteRef = createSubRouteRef({
  id: 'orquestra.planning.phase.new',
  parent: rootRouteRef,
  path: '/projects/:id/planning/phases/new',
});

export const phaseEditRouteRef = createSubRouteRef({
  id: 'orquestra.planning.phase.edit',
  parent: rootRouteRef,
  path: '/projects/:id/planning/phases/:phaseId/edit',
});

export const sprintNewRouteRef = createSubRouteRef({
  id: 'orquestra.planning.sprint.new',
  parent: rootRouteRef,
  path: '/projects/:id/planning/phases/:phaseId/sprints/new',
});

export const sprintEditRouteRef = createSubRouteRef({
  id: 'orquestra.planning.sprint.edit',
  parent: rootRouteRef,
  path: '/projects/:id/planning/phases/:phaseId/sprints/:sprintId/edit',
});

// Financial
export const financialRouteRef = createSubRouteRef({
  id: 'orquestra.financial',
  parent: rootRouteRef,
  path: '/projects/:id/financial',
});

export const financialPlanRouteRef = createSubRouteRef({
  id: 'orquestra.financial.plan',
  parent: rootRouteRef,
  path: '/projects/:id/financial/plano',
});

// Imagine / TO-BE
export const imagineRouteRef = createSubRouteRef({
  id: 'orquestra.imagine',
  parent: rootRouteRef,
  path: '/projects/:id/imagine',
});

export const processToBeRouteRef = createSubRouteRef({
  id: 'orquestra.process-to-be',
  parent: rootRouteRef,
  path: '/projects/:id/process-to-be',
});

// Imagine — Solucoes e Fases (paginas dedicadas)
export const imagineSolucaoNewRouteRef = createSubRouteRef({
  id: 'orquestra.imagine.solucao.new',
  parent: rootRouteRef,
  path: '/projects/:id/imagine/solucoes/new',
});

export const imagineSolucaoDetailRouteRef = createSubRouteRef({
  id: 'orquestra.imagine.solucao.detail',
  parent: rootRouteRef,
  path: '/projects/:id/imagine/solucoes/:solucaoId',
});

export const imagineSolucaoEditRouteRef = createSubRouteRef({
  id: 'orquestra.imagine.solucao.edit',
  parent: rootRouteRef,
  path: '/projects/:id/imagine/solucoes/:solucaoId/edit',
});

export const imagineFaseNewRouteRef = createSubRouteRef({
  id: 'orquestra.imagine.fase.new',
  parent: rootRouteRef,
  path: '/projects/:id/imagine/solucoes/:solucaoId/fases/new',
});

export const imagineFaseEditRouteRef = createSubRouteRef({
  id: 'orquestra.imagine.fase.edit',
  parent: rootRouteRef,
  path: '/projects/:id/imagine/solucoes/:solucaoId/fases/:faseId/edit',
});

export const imagineFuncionalidadeNewRouteRef = createSubRouteRef({
  id: 'orquestra.imagine.funcionalidade.new',
  parent: rootRouteRef,
  path: '/projects/:id/imagine/solucoes/:solucaoId/funcionalidades/new',
});

export const imagineFuncionalidadeEditRouteRef = createSubRouteRef({
  id: 'orquestra.imagine.funcionalidade.edit',
  parent: rootRouteRef,
  path: '/projects/:id/imagine/solucoes/:solucaoId/funcionalidades/:funcionalidadeId/edit',
});

// Dashboards
export const dashboardFinancialRouteRef = createSubRouteRef({
  id: 'orquestra.dashboards.financial',
  parent: rootRouteRef,
  path: '/dashboards/financial',
});

export const dashboardManagementRouteRef = createSubRouteRef({
  id: 'orquestra.dashboards.management',
  parent: rootRouteRef,
  path: '/dashboards/management',
});

/**
 * Lista central de todos os subRouteRefs exportados pelo plugin.
 * Utilizada pelo teste generico multi-rota que valida ausencia de `*`
 * nas URLs geradas (RF2.1). Novos subRouteRefs DEVEM ser adicionados aqui.
 */
export const allSubRouteRefs = [
  processAsIsListRouteRef,
  processAsIsNewRouteRef,
  processAsIsEditRouteRef,
  processAsIsViewRouteRef,
  gapsAggregatedRouteRef,
  gapNewRouteRef,
  gapEditRouteRef,
  activityNewRouteRef,
  activityEditRouteRef,
  projectNewRouteRef,
  projectDetailRouteRef,
  projectEditRouteRef,
  planningRouteRef,
  planningGanttRouteRef,
  phaseNewRouteRef,
  phaseEditRouteRef,
  sprintNewRouteRef,
  sprintEditRouteRef,
  financialRouteRef,
  financialPlanRouteRef,
  imagineRouteRef,
  processToBeRouteRef,
  imagineSolucaoNewRouteRef,
  imagineSolucaoDetailRouteRef,
  imagineSolucaoEditRouteRef,
  imagineFaseNewRouteRef,
  imagineFaseEditRouteRef,
  imagineFuncionalidadeNewRouteRef,
  imagineFuncionalidadeEditRouteRef,
  dashboardFinancialRouteRef,
  dashboardManagementRouteRef,
] as const;
